export const getMyHomeLink = (address: string): string => {
  return `/my-home/?address=${address}&from=card_jk_building_progress`;
};
